import { useContext } from 'react';
import { headerHeightContext } from "../contexts/headerHeightContext.js";
export function useHeaderHeight() {
  return useContext(headerHeightContext)?.height ?? 0;
}